import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import deTranslations from './translations/de';
import enTranslations from './translations/en';
import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from './config';

// Detect browser language
const browserLang = navigator.language.split('-')[0].toLowerCase();
console.log('i18n initializing with browser language:', browserLang);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      de: deTranslations,
      en: enTranslations
    },
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGES,
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['path', 'navigator', 'localStorage', 'htmlTag', 'cookie'],
      lookupFromPathIndex: 1,
      caches: ['localStorage'],
      checkWhitelist: true
    },
    load: 'languageOnly',
    lng: SUPPORTED_LANGUAGES.includes(browserLang as any) ? browserLang : DEFAULT_LANGUAGE
  });

export default i18n;